/**
 * 493128 - "Encerrar Orcamento" nao aparece.
 *
 * A verificacao anterior ordenava os dois arrays e comparava POSICAO A POSICAO, de modo que uma
 * resposta remanescente de pergunta que saiu da tela (ex.: "Deseja continuar com Datas Diferentes?",
 * que deixa de ser perguntada em "Apenas Orcamento") desalinhava a comparacao e escondia o botao,
 * mesmo com todas as perguntas exibidas devidamente respondidas.
 *
 * A checagem correta e de SUBCONJUNTO: basta que cada pergunta exibida tenha resposta. Assim, apenas
 * pergunta visivel na tela pode bloquear o botao. Usa `in`, o mesmo critério dos radios Sim/Nao em
 * FinalizarOrcamento.tsx, para que tela e botao decidam pela mesma regra.
 */
export const todasPerguntasRespondidas = (
    codigosPerguntas: string[],
    respostas: { [codigoPergunta: string]: boolean }
) => codigosPerguntas.every(codigoPergunta => codigoPergunta in (respostas ?? {}))
